module.exports = __webpack_public_path__ + "static/media/logo-wordpress.f033eb37.svg";